<template>
  <el-dialog
    title="兑换会员卡"
    width="520px"
    :visible.sync="dialog.isShow"
    @close='closeDialog'
    @open='openDialog'
  >
    <el-form
      :model="form"
      label-width="80px"
      class="dr-form"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="验证码"
            prop="code"
          >
          <el-input v-model="form.code" placeholder="请输入验证码"></el-input>   
          </el-form-item>
        </el-col> 
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dr-dialog-footer"
    >
      <el-button @click="dialog.isShow = false">
        关 闭
      </el-button>
      <el-button
        type="primary"
        @click="Save"
      >
       保 存
      </el-button>
    </div>
   </el-dialog>
</template>
<script  type='text/ecmascript-6'>
  import { Loading } from 'element-ui';
  export default {
    props:{
      dialog:{}
    },
    data(){
      return {
        loading:false,
        form:{
          memberId:0,
          code:'',
        }
      }
    },
    mounted(){
      
    },
    components:{    
      
    },
    methods:{      
      closeDialog:function(){
          this.dialog.isShow = false
      },
      openDialog:function(){
        this.form.memberId = this.dialog.id
        this.form.code = ''
      },
      Save:function(){
        var that = this
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/member/ExchangeCard',         
          data:this.form
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);            
            that.dialog.isShow = false
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      }
    }
   }
</script>
